<template>
  <div class="head-page">
    <Header :title="$t('security.resetlegalpwd')" />
    <van-form @submit="onSubmit">
      <van-field
        v-model="frm.logpassword"
        type="password"
        :label="$t('security.modifypwd')"
        :placeholder="$t('security.loginpwdplaceholder')"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="frm.newpassword"
        type="password"
        :label="$t('security.resetlegalpwd')"
        :placeholder="$t('security.moneypwd')"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="password"
        type="password"
        name="validator"
        :label="$t('security.pwdage')"
        :placeholder="$t('security.pwdageplaceholder')"
        :rules="[
          { required: true },
          { validator, message: $t('register.agepwdplaceholder1') },
        ]"
      />
      <div style="margin: 16px">
        <van-button class="web-btn" native-type="submit">
          <van-loading v-if="posting" /><span v-else>
            {{ $t("common.submit") }}</span
          ></van-button
        >
      </div>
    </van-form>
  </div>
</template>
  
  <script>
import Header from "@/components/Header";
export default {
  name: "ResetLegalPwd",
  components: { Header },
  data() {
    return {
      frm: {
        logpassword: null,
        newpassword: null,
      },
      password: null,
      posting: false,
    };
  },
  methods: {
    async onSubmit() {
      if (this.posting) {
        return;
      }
      this.posting = true;
      if (this.type == 0) this.frm.email = this.tmp;
      else this.frm.phone = this.tmp;
      await this.$http({
        method: "post",
        url: "resetpay",
        data: this.frm,
      })
        .then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
          (this.frm = {
            logpassword: null,
            newpassword: null,
          }),
            (this.password = null);
        })
        .catch(() => {
          this.posting = false;
        });
    },
    validator(val) {
      return this.frm.newpassword == val;
    },
  },
};
</script>
  
